export const DIRECT_TICKET_TAG = 'direct_ticket';
